class ProductTabs extends HTMLElement {
    constructor() {
        super();
        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        this.isVerticalPopup = this.dataset.vertical === 'sidebar';
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile';

        this.tab.forEach((element) => {
            element.addEventListener('click', this.tabActive.bind(this));
        });

        this.link.forEach((element) => {
            element.addEventListener('click', this.tabToggle.bind(this));
        });

        this.readMore.forEach((element) => {
            element.setAttribute('aria-expanded', 'false');
            element.addEventListener('click', this.readMoreReadLess.bind(this));
        });

        this.tabClose.forEach((element) => {
            element.addEventListener('click', (event) => {
                this.productTabClose(event);
                if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
                    this.handleVerticalPopupClose(event);
                }
            });
        });

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
            document.querySelector('.background-overlay')?.addEventListener('click', this.onBackgroundClick.bind(this));
        }
    }

    tabActive(event) {
        event.preventDefault();
        event.stopPropagation();
        const current = event.currentTarget;
        const id = current.getAttribute('href').replace('#', '');
        const buttonTab = document.querySelector('.an-horizontal-shaking');

        if (!current.classList.contains('is-open')) {
            this.tab.forEach((element) => element.classList.remove('is-open'));
            current.classList.add('is-open');
            this.tabContents.classList.add('is-show');
            buttonTab?.classList.add('open-tab-content');
            this.tabContent.forEach((element) => {
                element.classList.toggle('is-active', element.getAttribute('id') === id);
            });
        }

        if (current.classList.contains('open-tab-content')) {
            buttonTab?.classList.remove('open-tab-content');
        }

        this.checkTabShowMore(id);
    }

    tabToggle(event) {
        event.preventDefault();
        event.stopPropagation();
        const current = event.currentTarget;
        const content = current.parentNode.nextElementSibling;

        if (current.classList.contains('popup-mobile') && window.innerWidth <= 551) {
            content.classList.toggle('is-show');
        } else if (window.innerWidth <= 551 && current.classList.contains('show-mobile')) {
            current.classList.remove('is-open', 'show-mobile');
            $(content).slideUp('slow');
        } else if (current.classList.contains('is-open')) {
            current.classList.remove('is-open');
            if ((this.isVerticalPopup && window.innerWidth > 550) || (current.matches('.sidebar-mobile') && window.innerWidth <= 550)) {
                content.classList.remove('is-show');
                document.body.classList.remove('tab-popup-show');
            } else {
                $(content).slideUp('slow');
            }
        } else {
            current.classList.add('is-open');
            if ((this.isVerticalPopup && window.innerWidth > 550) || (current.matches('.sidebar-mobile') && window.innerWidth <= 550)) {
                content.classList.add('is-show');
                document.body.classList.add('tab-popup-show');
            } else {
                $(content).slideDown('slow');
            }
        }
    }

    readMoreReadLess(event) {
        event.preventDefault();
        event.stopPropagation();
        const current = event.currentTarget;
        const id = current.getAttribute('href').replace('#', '');
        const showMoreText = current.getAttribute('data-show-more-text');
        const showLessText = current.getAttribute('data-show-less-text');
        const showMoreContainer = current.closest('.tab-showMore');
        const description = this.querySelector(`#${CSS.escape(id)}`);

        if (!showMoreContainer || !description) {
            return;
        }

        const descriptionMax = showMoreContainer.dataset.desMax;
        const isExpanded = current.classList.contains('is-less');

        showMoreContainer.classList.toggle('is-less', !isExpanded);
        showMoreContainer.classList.toggle('is-show', isExpanded);
        current.classList.toggle('is-less', !isExpanded);
        current.classList.toggle('is-show', isExpanded);
        current.setAttribute('aria-expanded', String(!isExpanded));
        current.innerText = isExpanded ? showMoreText : showLessText;
        description.style.maxHeight = isExpanded ? `${descriptionMax}px` : 'unset';

        if (isExpanded) {
            this.tabContents.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
    }

    productTabClose(event) {
        event.preventDefault();
        event.stopPropagation();
        this.tabContents.classList.remove('is-show');
        this.tab.forEach((element) => element.classList.remove('is-open'));
        this.tabContent.forEach((element) => element.classList.remove('is-active'));
        document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');

        if (window.innerWidth <= 551) {
            event.currentTarget.closest('.toggle-content')?.classList.remove('is-show');
        }
    }

    checkTabShowMore(id) {
        if (window.innerWidth <= 550) {
            return;
        }

        const content = this.querySelector(`#${CSS.escape(id)}`);
        const showMore = content?.querySelector('.tab-showMore');
        if (!content || !showMore) {
            return;
        }

        const maxHeight = Number.parseInt(showMore.dataset.desMax, 10);
        if (content.scrollHeight <= maxHeight) {
            showMore.remove();
            content.style.maxHeight = 'unset';
        }
    }

    onBackgroundClick(event) {
        if (!event.target.closest('.toggle-content.is-show')) {
            this.querySelector('.toggleLink.is-open')?.classList.remove('is-open');
            this.querySelector('.toggle-content.is-show')?.classList.remove('is-show');
            document.body.classList.remove('tab-popup-show');
        }
    }

    handleVerticalPopupClose(event) {
        const icon = event.currentTarget;
        icon.closest('.toggle-content')?.classList.remove('is-show');
        icon.closest('.tab-content')?.querySelector('.toggleLink')?.classList.remove('is-open');
        document.body.classList.remove('tab-popup-show');
    }
}

customElements.define('product-tab', ProductTabs);
